export default __webpack_public_path__ + "static/media/doge.4f67e0fe.svg";